module.exports = __webpack_public_path__ + "images/8676b9aae3e4129bfc1cba5cab0b1f57.webp";